<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true"
  [style]="{'max-width':'500px','width':'70%','border':'none','border-radius':'5px'}">

  <p-header>
    <div class="d-flex flex-row justify-content-between mx-2 mt-1 qma-text">
      <h6 class="popup-title1  align-self-center">{{headerText}}</h6>
      <button type="button" (click)="hideModal()" class="d-flex flex-row close qma-text p-1">
        <img src="assets/Inbox/close_icon_white.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div class="popup-body mx-2">
    <form>
      <div class="d-flex align-items-center justify-content-center h-40 my-3 py-2 px-2" style="font-size: 15px;">
        <label>{{labelText}}</label>
      </div>      
    </form>
  </div>
  <p-footer *ngIf="isMessage">
    <div class="d-flex flex-row flex-wrap bottom-button-holder px-3 pb-2 pt-0 justify-content-center">
      <button *ngIf="showConfirm" class="btn search-btn me-4" (click)="confirm()">Confirm</button>
      <button *ngIf="showOK" type="reset" class="btn clear-btn action-yes-btn" (click)="ok()">OK</button>
      <button *ngIf="showCancel" type="reset" class="btn clear-btn" (click)="cancel()">Cancel</button>
      <button *ngIf="showNo" type="reset" class="btn clear-btn action-no-btn" (click)="no()">No</button>
      <button *ngIf="showYes" type="reset" class="btn clear-btn action-yes-btn" (click)="yes()">Yes</button>
    </div>
  </p-footer>
</p-dialog>